import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-conselho-administrativo',
  templateUrl: './conselho-administrativo.component.html',
  styleUrls: ['./conselho-administrativo.component.css']
})
export class ConselhoAdministrativoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
